export class SppedMateHttpError {
  constructor(error: any) {
    if (error) {
      const { response } = error;
      if (response) {
        const { data } = response;

        if (data) {
          const { error, message, translate, statusCode = -1 } = data;
          this.error = error;
          this.status = statusCode;
          this.notTranslate = translate || "";

          if (typeof message === "string") {
            this.notTranslate = message;
            this.message = translate || message;
          } else if (Array.isArray(message)) {
            this.notTranslate = message[0] || "";
            if (translate) this.message = translate[0] || "";
            else this.message = message[0] || "";
          } else {
            this.notTranslate = message || "";
            this.message = translate || "";
          }
          if (statusCode === 401 || statusCode === 403) this.message = "";
        }
      }
    }
  }

  // Http status
  status: number;

  // 오류 메시지
  message: string;

  notTranslate?: string;

  // 오류 코드
  error: string;
}
